// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__+cv0L","loading":"skeleton_loading__ukO+6"};